import PropTypes from "prop-types";
import React from "react";

function MonthGrid({ children, editCalendar = false, startDay = 0 }, {}) {

  const days = editCalendar
    ? [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ]
    : ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
  const finalDay = [
    ...days.slice(startDay || 0),
    ...days.slice(0, startDay || 0),
  ];
  return (
    <div className="calendar-month-wrapper">
      <section className={`Calendar-Month${editCalendar ? " edit-modex" : ""}`}>
        <article>
          {editCalendar ? <div className="invisible" /> : null}
          {finalDay.map((day, idx) => (
            <p key={`${day}${idx}`} className="s2">
              {day}
            </p>
          ))}
        </article>
        {children}
      </section>
    </div>
  );
}

MonthGrid.contextTypes = { locals: PropTypes.object };

export default MonthGrid;
